import { render, staticRenderFns } from "./ResultsEditor.vue?vue&type=template&id=451bce0e&scoped=true&"
import script from "./ResultsEditor.vue?vue&type=script&lang=js&"
export * from "./ResultsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451bce0e",
  null
  
)

export default component.exports